import { inject, Injector } from '@angular/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

export const LANGUAGE_STORAGE_KEY = 'app_language';

export async function initI18n(): Promise<void> {
  const injector = inject(Injector);
  const translate = inject(TranslateService);

  await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
  translate.addLangs(['pl', 'ru', 'en', 'de']);

  const storedLang = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  const browserLang = translate.getBrowserLang();
  const available = ['pl', 'ru', 'en', 'de'];
  
  let defaultLang = 'pl';
  if (storedLang && available.includes(storedLang)) {
    defaultLang = storedLang;
  } else if (browserLang && available.includes(browserLang)) {
    defaultLang = browserLang;
  }

  translate.setDefaultLang(defaultLang);
  translate.setFallbackLang('pl');

  try {
    await firstValueFrom(translate.use(defaultLang));
  } catch (err) {
    console.error(err);
  }
}

export function saveLanguageToStorage(language: string): void {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
}

export function getStoredLanguage(): string | null {
  return localStorage.getItem(LANGUAGE_STORAGE_KEY);
}
